import { DTN_STEPS } from '../../steps';
import DeliveryPreferencesStep from '../../components/DeliveryPreferencesStep';

export default DeliveryPreferencesStep(DTN_STEPS);
